const ERROR_CODE = {
  BAD_USER_INPUT: 'BAD_USER_INPUT',
  FORBIDDEN: 'FORBIDDEN',
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
};

export default ERROR_CODE;
